import actions from "./actions";
import mutations from "./mutations";
import { pagination } from "@/store/helpers";

export default {
  namespaced: true,
  state: {
    servers: {
      ...pagination,
    },
    loading: false,
    query: "",
  },
  getters: {
    getQuery(state) {
      return state.query;
    },
  },
  actions,
  mutations,
};
